<template>
  <zen-one 
    :showuserinfo="true" 
    :crumbs="crumbs"
    title="PENTADBIRAN : Tetapan Pentaksiran PBD"
  >
    <z-page title=" Senarai Tetapan Pentaksiran PBD">
      <template #buttons>
        <w-button icon="fal fa-circle" text md class="ml0" color="success"></w-button>
      </template>

      <w-flex class="grow justify-space-betweenx basis-zero" v-if="1">
        <z-dashboard-item 
          class="box dash box-s1"  
          :use-icon="false" 
          image="/images/boy-dark.png"
          header=
          '
              <span class="box-s1-title success text-bold">45</span> 
              <span class="box-s1-title">/ 90</span>
          '
          title='Lelaki'
          subtitle='21 Oktober 2021'
        >
        </z-dashboard-item>

        <z-dashboard-item 
          class="box dash box-s1 ml3 " 
          :use-icon="false" 
          image="/images/girl-dark.png" 
          header=
          '
            <span class="box-s1-title success text-bold">45</span> 
              <span class="box-s1-title">/ 90</span>
          '
          title='Perempuan'
          subtitle='21 Oktober 2021'
        >
        </z-dashboard-item>
      </w-flex>


      <w-dialog
        v-model="dialog.show"
        :fullscreen="dialog.fullscreen"
        :width="dialog.width"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-light1--bg white">
        <template #title>
          <w-icon class="mr2">fal fa-cog</w-icon>
          Sunting
        </template>

        <w-form 
          ref="dform" 
          v-model="dialog.valid"
          @validate="submit"
          @success="success"
        >
        <z-input label="Name" v-model="dialog.item.name" name="name" :validators="[validators.required]" />

        <z-input class="mt3" label="Email" v-model="dialog.item.email" name="email" :validators="[validators.required]" />

        <z-input class="mt3" label="Mobile" v-model="dialog.item.mobile" name="mobile" :validators="[validators.required]" />

        </w-form>

        
        <template #actions>
          <div class="spacer" />
          <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
          <w-button 
          class="ml1" 
          :loading="dialog.loading"
          :disabled="dialog.valid === false"
          @click="$refs.dform.validate()"
          >
            Simpan
          </w-button>
        </template>

        
      </w-dialog>

      <w-form 
        ref="zform" 
      >
        <w-card bg-color="" class="mt3">
          <w-flex class="mt3">
            <div class="xs4">
                <h5 class="fw-semibold m0 fs-2">
                    Sesi Persekolahan :
                </h5>
                <div class="fw-normal my1 fs-1 mt2"> 2020/2021 </div>
            </div>
            <div class="xs4">
                <h5 class="fw-semibold m0 fs-2">
                    Aktiviti :
                </h5>
                <div class="fw-normal my1 fs-1 mt2"> PEPERIKSAAN PERTENGAHAN TAHUN </div>
            </div>
            <div class="xs4">
                <h5 class="fw-semibold m0 fs-2">
                    Komponen :
                </h5>
                <div class="fw-normal my1 fs-1 mt2"> ALIRAN PERDANA </div>
            </div>
          </w-flex>

          <w-flex class="mt3 mb4">
              <div class="xs4">
                  <h5 class="fw-semibold m0 fs-2">
                      Tempoh Taksiran :
                  </h5>
                  <div class="fw-normal my1 fs-1 mt2"> 01/06/2021 - 30/06/2021 </div>
              </div>
              <div class="xs4">
                  <h5 class="fw-semibold m0 fs-2">
                      Tarikh Laporan :
                  </h5>
                  <div class="fw-normal my1 fs-1 mt2"> 31/07/2021 </div>
              </div>
          </w-flex>

          <z-table
            ref="tblEmployee"
            title="Senarai Pelajar Yang Didaftarkan"
            :headers="table.headers"
            :items="table.items"
            :meta="table.meta"
            class=""
          >
          
            <template #header-label="{ header, label, index }">
              <template v-if="header.key == 'action'">
              <w-icon>fal fa-pencil</w-icon>
              </template>
              <template v-else>
              {{ label }}
              </template>
              
            </template>

            <template #item-cell.keputusan="{ item, label, header, index }">
              <div class="px2">
                  <w-rating class="my2" xl :max="6" icon="fal fa-circle">
                    <template #item="{item}">
                    
                    </template>
                  </w-rating>
                  <w-input v-if="0" label="Keputusan" v-model="item.keputusan" :validators="[validators.required]" />
                
              </div>
            </template>

            <template #item-cell.gred="{ item, label, header, index }">
              <div class="px2">
                
                  <w-select label="Gred" v-model="item.gred" :items="[{label: 'A++'}, {label: 'A'}, {label: 'B'}]" />
                
              </div>
            </template>

            <template #item-cell.action="{ item, label, header, index }">
              <w-flex class="flex justify-center">
                <w-button bg-color="primary-dark1" class="box  sh1" @click="showDialog(item)">
                  <w-icon >fal fa-pencil</w-icon>
                </w-button>
                <w-button bg-color="white" class="box primary-dark1  sh1">
                  <w-icon md class="mr1" >fal fa-edit</w-icon> Lanjut Tempoh 
                </w-button>
              </w-flex>
            </template>

          </z-table>
        </w-card>
        

        <div class="mt2 text-right">
          <w-button 
            type="submit"
            class="text-bold" 
            bg-color="z-primary-grad"
            :loading="loading"
          >
            <w-icon>fal fa-save</w-icon>&nbsp;Simpan
          </w-button>
        </div>
      </w-form>
    </z-page>
  </zen-one>
</template>

<script>
export default {
  props: {
    employees: [Array, Object],
  },
  data() {
    return {
      loading: false,
      crumbs: [
        { label: 'zTemplate', route: '/sitemap' },
        { label: 'Home', route: '/' },
        { label: 'Record', route: '/record' }
      ],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
        item: {name: '', email: '', mobile: ''}
      },
      table: {
        headers: [
          { label: 'ID', key: 'id' },
          { label: 'First name', key: 'firstName' },
          { label: 'Last name', key: 'lastName' },
          { label: 'Keputusan', key: 'keputusan' },
          { label: 'Gred', key: 'gred' },
          { label: 'Tindakan', key: 'action', align: 'center' }
        ],
        items: [
          
        ],
        keyword: '',
        keywordFilter: keyword => item => {
          // Concatenate all the columns into a single string for a faster lookup.
          const allTheColumns = `${item.id} ${item.name} ${item.email}`

          // Lookup the keyword variable in the string with case-insensitive flag.
          return new RegExp(keyword, 'i').test(allTheColumns)
        },
        meta: [
          {last_page: 1}
        ]
      },
      validators: {
        required: value => !!value || 'This field is required'
        // Other validators...
      }
    }
  },
  methods: {
    submit () {
      this.dialog.loading = true
      // setTimeout(() => (this.loading = false), 3000)
      this.$zcomm.update(window.route('employee.update',this.dialog.item.id),this.dialog.item.id,this.dialog.item)
      .then(res => {
        this.dialog.show = false    
        this.dialog.loading = false
      })
      .catch(err => {
        this.dialog.valid = false
        this.dialog.loading = false
      })
    
    },
    success () {
      this.loading = true
      setTimeout(() => (this.loading = false), 3000)
    },
    showDialog(item) {
      this.dialog.show = !this.dialog.show
      this.dialog.item = item
    }
  },
  watch: {
    employees: {
      handler () {
        // console.log(this.employees)
        this.table.headers = this.employees.data.headers
        this.table.items = this.employees.data.items
        this.table.meta = this.employees.meta

      },
      deep: true,
    }
  },
  mounted() {
      if(this.employees) {
        this.table.headers = this.employees.data.headers
        this.table.items = this.employees.data.items
        this.table.meta = this.employees.meta
      }
    
  },
}
</script>

<style>

.fs-1 {
    text-transform: uppercase;
}
.fs-2{
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: .02rem;
    color: #070c4a;
}
.box-s1-title {
    font-size: 30px !important;
}
</style>